import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import DeleteAccount from "../src/components/DeleteAccount/deleteAccount";
import Login from "../src/components/Login/login";
import GlobalStoreProvider from "../src/context/GlobalStoreProvider";
import "./searchApp.css";

const LoginApp = () => {
    return (
        <GlobalStoreProvider>
            <Router>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/delete_account" element={<DeleteView />} />
                </Routes>
            </Router>
        </GlobalStoreProvider>
    );
};

export default LoginApp;

function DeleteView() {
    return (
        <>
            <GlobalStoreProvider>
                <DeleteAccount />
            </GlobalStoreProvider>
        </>
    );
}
